import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthStateService} from '@auth/states';
import {AppInitialization} from '@core/services';

export const adminGuard: CanActivateFn = async (route, state) => {

  const router = inject(Router);
  const authState = inject(AuthStateService);
  const appInitilization = inject(AppInitialization);

  await appInitilization.checkInitialization();

  return authState.isAdmin() || router.parseUrl("/dashboard");
};
